
import React, { useEffect, useRef } from 'react'
import './choosewallet.scss'
const Choosewallet = () => {
  return (
    <>
     <section className='topicwhitepaperprnt'>
               
                <div className="custom-container">
                    <div className="topicswhitepaperchldmain">
                        <div className="headerchoosewallet">

                        {/* <h6>Why Choose TOMI Wallet?</h6> */}
                        <h2>Why Choose TOMI Wallet?</h2>
                        <p>Discover the AI-powered Web3 wallet that combines security, simplicity, and hands-free control.</p>
                        </div>
                        <div className="cardtopicsmain">
                            <dic className="card1topicwhitepaper" >
                                <h6>//01</h6>
                                <h3>AI Voice Assistant</h3>
                                <p>Send crypto, check balances & more with voice commands.</p>
                            </dic>
                            <dic className="card1topicwhitepaper" >
                                <h6>//02</h6>
                                <h3>Seamless Transactions</h3>
                                <p>Buy, sell, and send crypto with an intuitive interface.</p>
                            </dic>
                            <dic className="card1topicwhitepaper" >
                                <h6>//03</h6>
                                <h3>User-Friendly Design</h3>
                                <p>Navigate Web3 effortlessly with AI-powered assistance.</p>
                            </dic>
                            
                         
                            <dic className="card1topicwhitepaper">
                                <h6>//04</h6>
                                <h3>Enhanced Security</h3>
                                <p>Full self-custody with biometric authentication.</p>
                            </dic>
                            <dic className="card1topicwhitepaper" >
                                <h6>//05</h6>
                                <h3>Multi-Chain Support</h3>
                                <p>Securely manage assets across multiple blockchains.</p>
                            </dic>
                            <dic className="card1topicwhitepaper">
                                <h6>//06</h6>
                                <h3>NFT & dApp Access</h3>
                                <p>Interact with decentralized apps and NFT platforms.</p>
                            </dic>
                        </div>
                    </div>
                </div>
            </section>
    
    </>
  )
}

export default Choosewallet